import React from 'react';
import { getDetailTabTitle } from '../utils/productDetailTabs';
import { sanitizeTabHtml, stripHtmlText } from '../utils/sanitizeHtml';

const renderHtmlBlock = (tab, { showSectionHeading = false } = {}) => {
  const html = sanitizeTabHtml(tab?.TabHtmlContent);
  if (!html || !stripHtmlText(html)) {
    return <p className="text-muted mb-0">No details available.</p>;
  }

  const sectionTitle = getDetailTabTitle(tab);

  return (
    <div className="sk-detail-tab-html-section">
      {showSectionHeading ? (
        <>
          <hr className="sk-spec-section-divider" />
          <h4 className="title-detail mb-15">{sectionTitle}</h4>
        </>
      ) : null}
      <div
        className="sk-detail-tab-html product-feature-html"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {showSectionHeading ? <hr className="sk-spec-section-divider sk-spec-section-divider-bottom" /> : null}
    </div>
  );
};

export function ProductDetailSidebarContent({ tab, product }) {
  const contentType = tab?.ContentType;

  if (contentType !== 'html_block' || tab?.Placement !== 'sidebar') {
    return null;
  }

  const html = sanitizeTabHtml(tab?.TabHtmlContent);
  if (!html || !stripHtmlText(html)) {
    return null;
  }

  return (
    <div
      className="sk-detail-tab-html sk-detail-tab-html-sidebar product-feature-html"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

export function ProductDetailTabContent({ tab, product }) {
  const contentType = tab?.ContentType;

  if (contentType === 'html_block') {
    return renderHtmlBlock(tab, { showSectionHeading: false });
  }

  if (contentType === 'vendor_block') {
    return (
      <>
        <div className="vendor-logo d-flex mb-30">
          <img src={product.VendorLogo || '/assets/imgs/theme/sklogo.png'} alt="" style={{ width: '50px', height: '50px' }} />
          <div className="vendor-name">
            <h3>
              <a href="vendor-details-2">{product.VendorName || 'Vendor'}</a>
            </h3>
            <div className="product-rate-cover text-end">
              <div className="product-rate d-inline-block">
                <div
                  className="product-rating"
                  style={{ width: `${Math.min(100, Math.round((Number(product.VendorRating || 0) / 5) * 100))}%` }}
                />
              </div>
              <span className="font-small ml-5 text-muted"> ({product.VendorReviewCount || 0} reviews)</span>
            </div>
          </div>
        </div>
        <ul className="contact-infor mb-50">
          <li><img src="/assets/imgs/theme/icons/icon-location.svg" alt="" /><strong>Address : </strong> <span>{product.VendorAddress || '-'}</span></li>
          <li><img src="/assets/imgs/theme/icons/icon-contact.svg" alt="" /><strong>Contact Seller :</strong><span>{product.VendorContactNumber || '-'}</span></li>
        </ul>
      </>
    );
  }

  if (contentType === 'review_block') {
    return null;
  }

  return <p className="text-muted mb-0">Content not available.</p>;
}

export default ProductDetailTabContent;
